import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const SubtitlesGeneratorApi = {
    getStatus: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['subtitlesGenerator', 'getStatus', webinarId], (api) => api.subtitlesGenerator.getStatus(webinarId), options),
    getOptions: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['subtitlesGenerator', 'getOptions', webinarId], (api) => api.subtitlesGenerator.getOptions(webinarId), options),
    generateSubtitles: (options?: BaseApiMutationOptions<ApiClient['subtitlesGenerator']['generateSubtitles']>) =>
        apiMutationOptions((api) => api.subtitlesGenerator.generateSubtitles, options)
};
